"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "18", height: "4", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("circle", { cx: "2", cy: "2", r: "2", fill: "#1F1F1F" }),
    react_1.default.createElement("circle", { cx: "9", cy: "2", r: "2", fill: "#1F1F1F" }),
    react_1.default.createElement("circle", { cx: "16", cy: "2", r: "2", fill: "#1F1F1F" }))); };
exports.default = Component;
//# sourceMappingURL=Overflow.js.map